import { render, staticRenderFns } from "./baseDetailDialog.vue?vue&type=template&id=9f6faf9a&scoped=true&"
import script from "./baseDetailDialog.vue?vue&type=script&lang=js&"
export * from "./baseDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./baseDetailDialog.vue?vue&type=style&index=0&id=9f6faf9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6faf9a",
  null
  
)

export default component.exports